import { Link, useNavigate } from "react-router-dom";

interface BackToComplianceProps {
  profileNo: string;
}
const BackToCompliance = ({ profileNo }: BackToComplianceProps) => {
  const navigate = useNavigate();

  return (
    <span className="flex-fill w-100" style={{ display: "flex" }}>
      <a style={{ marginBottom: "10px" }} onClick={() => navigate(-1)}>
        &lt; Back to Previous Record
      </a>
    </span>
  );
};

export default BackToCompliance;
